'use client';

import { Image } from '@chakra-ui/react';
import { Link } from '@/i18n/navigation';

interface LogoProps {
  yapona?: boolean;
  /** When true, renders without Link wrapper (e.g. for use inside clickable parent) */
  noLink?: boolean;
}

const Logo = ({ yapona = false, noLink = false }: LogoProps) => {
  const imageProps = yapona
    ? { width: '132px', height: '42px', src: '/yapona.png' }
    : { width: '102px', height: '55px', src: '/mika.png' };

  const image = <Image {...imageProps} alt='logo' />;

  if (noLink) {
    return image;
  }

  return <Link href='/'>{image}</Link>;
};

export default Logo;
